module.exports = __webpack_public_path__ + "img/tmx_tortenet_3.3d17ddb4.png";